import { motion } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";

const STEPS = [
  { n: "01", title: "Présentation du besoin", text: "Vous décrivez votre espace et vos attentes via le formulaire de devis ou par téléphone." },
  { n: "02", title: "Étude de la demande", text: "DIMORA examine votre demande : type de prestation, surface, fréquence, contraintes." },
  { n: "03", title: "Proposition adaptée", text: "Vous recevez une proposition claire et personnalisée, sans engagement." },
  { n: "04", title: "Organisation de l'intervention", text: "Nous planifions ensemble la date, le créneau et les modalités d'accès." },
];

export const Steps = () => (
  <section id="etapes" data-testid="steps-section" className="py-24 sm:py-32 bg-[#0D1220]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-14 text-center"
      >
        <p className="text-xs uppercase tracking-[0.25em] text-amber-400 font-semibold mb-4">Comment ça se passe ?</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">
          Un parcours simple, <span className="text-amber-300">en 4 étapes</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.n}
            data-testid={`step-card-${i + 1}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="relative rounded-3xl border border-white/10 bg-[#111723]/75 card-glow p-7"
          >
            <span className="font-display text-4xl font-extrabold bg-gradient-to-b from-amber-200 to-amber-600 bg-clip-text text-transparent">
              {s.n}
            </span>
            <h3 className="mt-4 font-display text-lg font-semibold text-white">{s.title}</h3>
            <p className="mt-2 text-sm text-slate-400 leading-relaxed">{s.text}</p>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.3 }}
        className="mt-12 flex flex-wrap items-center justify-center gap-4"
      >
        <a
          href="#devis"
          data-testid="steps-devis-cta"
          className="group inline-flex items-center gap-2 rounded-full bg-amber-400 px-7 py-3.5 text-sm font-bold text-[#0A0D14] transition-all duration-300 hover:bg-amber-300 hover:scale-[1.03] active:scale-[0.97] hover:shadow-[0_0_35px_rgba(242,193,78,0.45)]"
        >
          Commencer ma demande de devis
          <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
        </a>
        <a
          href="tel:+33618907435"
          data-testid="steps-phone-cta"
          className="inline-flex items-center gap-2 rounded-full border border-white/20 px-7 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:border-amber-300/60 hover:text-amber-200"
        >
          <Phone className="w-4 h-4" /> 06 18 90 74 35
        </a>
      </motion.div>
    </div>
  </section>
);
